// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDocumentChecklists,
  downloadDocument,
  updateDocumentsChecklist,
  CalculateFees,
  ProceedToPay,
  CheckIsResubmittedPhase,
  GetLatestSoa,
  CheckMainSubmissionDone,
} from "@api";

export const getDocChecklists = createAsyncThunk(
  "documentchecklist/get_documents",
  async (args) => {
    const response = await getDocumentChecklists(args);
    return response.data;
  }
);

export const downloadDoc = createAsyncThunk(
  "documentchecklist/download_document",
  async (args) => {
    const response = await downloadDocument(args);
    return response.data;
  }
);

export const updateDocChecklists = createAsyncThunk(
  "documentchecklist/update_documents_checklist",
  async (args) => {
    const response = await updateDocumentsChecklist(args);
    return response.data;
  }
);

export const calculateFeesDocumentChecklist = createAsyncThunk(
  "payment/calculate_fees",
  async (args) => {
    const response = await CalculateFees(args);
    return response.data;
  }
);

export const proceedToPay = createAsyncThunk(
  "payment/proceed_to_pay",
  async (args) => {
    const response = await ProceedToPay(args);
    return response.data;
  }
);

export const getCheckIsResubmittedPhase = createAsyncThunk(
  "documentchecklist/check_isresubmitted_phase",
  async (args) => {
    const response = await CheckIsResubmittedPhase(args);
    return response.data;
  }
);

export const getLatestSoa = createAsyncThunk(
  "payment/get_latest_soa_docChecklist",
  async (args) => {
    const response = await GetLatestSoa(args);
    return response.data;
  }
);

export const checkMainSubmissionDoneDocChecklist = createAsyncThunk(
  "payment/check_mainsubmission_done_docChecklist",
  async (args) => {
    const response = await CheckMainSubmissionDone(args);
    return response.data;
  }
);

export const docChecklistSlice = createSlice({
  name: "docchecklist",
  initialState: {
    documents: [],
    caseNo: "",
    resubmittedDocuments: [],
    totalPayable: (0.0).toFixed(2),
    feeSubmissionGroupid: "",
    latestSoaStatus: "",
    isPaid: false,
    isPaymentProcessing: false,
    isResubmittedDocument: false,
  },
  reducers: {
    updateDocumentConfirmation(state, action) {
      const confirmedDoc = state.documents.find(
        (doc) => doc.id === action.payload.id
      );
      confirmedDoc.confirmed = action.payload.confirmed;
    },
    addResubmittedDocuments(state, action) {
      // Add Resubmit documents
      const existingResubmittedDoc = state.resubmittedDocuments.find(
        (doc) => doc.id === action.payload.id
      );
      if (!existingResubmittedDoc)
        state.resubmittedDocuments.push(action.payload);
    },
    updateResubmittedDocumentConfirmation(state, action) {
      const confirmedDoc = state.resubmittedDocuments.find(
        (doc) => doc.id === action.payload.id
      );
      confirmedDoc.confirmed = action.payload.confirmed;
    },
    clearResubmittedDocuments(state, action) {
      state.resubmittedDocuments = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocChecklists.fulfilled, (state, action) => {
        if (action.payload && action.payload.documents.length > 0) {
          state.documents = action.payload.documents;
          state.caseNo = action.payload.caseNo;
        } else state.documents = [];
      })
      .addCase(calculateFeesDocumentChecklist.fulfilled, (state, action) => {
        state.totalPayable = action.payload.TotalPayable.toFixed(2);
        state.feeSubmissionGroupid = action.payload.SubmissionGroupId;
      })
      .addCase(getCheckIsResubmittedPhase.fulfilled, (state, action) => {
        state.isResubmittedDocument = action.payload.isResubmitted;
      })
      .addCase(getLatestSoa.fulfilled, (state, action) => {
        /**
         * New - Next btn disabled, only enabled when checkbox is ticked in Presubmission
         * Pending - Always disabled Next btn
         * Accepted/Rejected - Always enabled Next btn
         */
        if (action.payload) state.latestSoaStatus = action.payload.status;
        else state.latestSoaStatus = "";
      })
      .addCase(
        checkMainSubmissionDoneDocChecklist.fulfilled,
        (state, action) => {
          /***
           * isPaid = True -> PostSubmission
           * isPaid = False -> PreSubmission
           */
          state.isPaid = action.payload.isPaid;
          state.isPaymentProcessing = action.payload.isPaymentProcessing;
        }
      );
  },
});

export const docChecklistActions = docChecklistSlice.actions;
export default docChecklistSlice.reducer;
